var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63529 15.3852C2.41378 16.8372 3.40413 17.8452 4.61668 18.3475C9.26539 20.2733 15.7345 20.2733 20.3832 18.3475C21.5958 17.8452 22.5861 16.8372 22.3647 15.3852C22.2285 14.4928 21.5554 13.7496 21.0566 13.024C20.4034 12.0619 20.3385 11.0125 20.3384 9.896C20.3384 5.58127 16.829 2.0835 12.5 2.0835C8.17093 2.0835 4.66155 5.58127 4.66155 9.896C4.66145 11.0125 4.59654 12.0619 3.9433 13.024C3.44459 13.7496 2.77143 14.4928 2.63529 15.3852Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 19.7915C8.81097 21.5886 10.4954 22.9165 12.5 22.9165C14.5047 22.9165 16.1891 21.5886 16.6667 19.7915",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhite);
export default __webpack_public_path__ + "static/media/notificationWhite.13b42ba43f0f9df6a49926ed8762cbc1.svg";
export { ForwardRef as ReactComponent };